import type {
  EstimateCapabilities, EstimateDraft, EstimateRevision,
} from '../api/constructionPriceEstimatorFunctions';

export function constructionResultPermissions({
  draft, revision, capabilities, isViewOnly, acknowledgedKeys, romAcknowledged,
}: {
  draft: EstimateDraft;
  revision: EstimateRevision | null;
  capabilities: EstimateCapabilities | undefined;
  isViewOnly: boolean;
  acknowledgedKeys: Set<string>;
  romAcknowledged: boolean;
}) {
  const isRom = revision?.mode === 'comparable_only_rom'
    || revision?.mode === 'historical_comparable_rom';
  const declared = Array.from(new Set([
    ...(draft.required_acknowledgements ?? []),
    ...(revision?.required_acknowledgements ?? []),
  ]));
  const romAckRequired = Boolean(isRom && !revision?.degradation?.acknowledged_at
    && (revision?.degradation?.acknowledgement_required
      || declared.includes('comparable_only_rom')
      || declared.includes('historical_comparable_rom')));
  const romAcknowledgementKey = declared.includes('historical_comparable_rom')
    ? 'historical_comparable_rom' : 'comparable_only_rom';
  const requiredAcknowledgements = declared.filter((key) => (
    key !== 'comparable_only_rom' && key !== 'historical_comparable_rom'
  ));
  const romFinalizationAllowed = !isRom
    || capabilities?.comparable_only_rom_finalization_available === true;
  const canFinalize = !isViewOnly && revision?.status === 'calculated'
    && capabilities?.can_finalize === true && romFinalizationAllowed
    && requiredAcknowledgements.every((key) => acknowledgedKeys.has(key))
    && (!romAckRequired || romAcknowledged);
  const canExport = Boolean(revision && capabilities?.export_available === true
    && capabilities?.can_export === true
    && ((!isViewOnly && capabilities.can_edit !== false && capabilities.enabled)
      || revision.status === 'finalized'));
  return {
    isRom, romAckRequired, romAcknowledgementKey,
    requiredAcknowledgements, romFinalizationAllowed, canFinalize, canExport,
  };
}
